import React from 'react'
import { Link } from 'react-router-dom'
import plus from '../dist/webImages/plus.png'
import Skeleton, { SkeletonTheme } from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';


const SkeletonRoleList = () => {
  return (
    <SkeletonTheme baseColor="#EFF4FD" highlightColor="#D4DEF1">
      <div className='services'>
        <div className="servicesTop flex justify-end items-center mb-4">
          {/* <h6 className='text-[1rem] mb-2 bookingSectionh relative px-3 font-Mluvka'> Role</h6> */}
          <Link to={"/role/create"} className='bg-[#A38560]/50 py-2 px-4 rounded-full flex items-center gap-2 cursor-pointer' >
            <img src={plus} alt="plus" className="w-6" />
            <span className='font-MluvkaBold text-secondary capitalize text-[.9rem]'>Add Role</span>
          </Link>
        </div>
        <div className="servicesBottom grid grid-cols-6 gap-4 max-lg:grid-cols-1">
          {[...Array(16)].map((_, index) => (
            <div key={index} className="servicesCard border-2 border-[#ddd] p-3 rounded-2xl">
              <div className="lawyerCard__img mx-auto flex justify-center">
                <Skeleton width="3.5rem" height="3.5rem" className='mx-auto rounded-full' />
              </div>
              <div className="servicesCard__Body text-center mt-3">
                <Skeleton height={24} width="80% " />
              </div>
              <div className="servicesCard__Body grid grid-cols-2 gap-2 mt-3">
                <Skeleton height={24} width="100%" />
                <Skeleton height={24} width="100%" />
              </div>
            </div>
          ))}
        </div>
      </div>
    </SkeletonTheme>
  )
}

export default SkeletonRoleList